
import { withStyles } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { change, initialize, submit } from 'redux-form';
import * as formatter from '../../../_config/formatter';
import { DEFAULT_CREDENTIAL_TIME_FRAME, LANGUAGES } from '../../../_config/consts';
import OperationalView from '../../../components/OperationalView/OperationalView.jsx';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import CompanyTimeProfilesListView from '../../Company/CompanyTimeProfilesListView.jsx';
import CompanyTimeProfileForm from '../../forms/CompanyTimeProfileForm.jsx';
import CompanyTimeProfileSearchForm from '../../forms/TimeProfiles/CompanyTimeProfileSearchForm.jsx';

const styles = {
  container: {
  },
  boldText: {
    margin: 0,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
};
@withRouter
@connect(state => ({ companyTimeProfiles: state.user.companyTimeProfiles, form: state.form.CompanyTimeProfileForm, companyConfigurations: state.user.companyConfigurations, language: state.settings.language, themeName: state.settings.items.theme.data.themeName }))
class CompanyTimeProfilesSettingsOperationalSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isViewLoading: false,
      isFormVisible: false,
      timeProfiles: [],
    };
  }

  async componentDidMount() {
    this.onFetchTimeProfiles();
  }

  async onFetchTimeProfiles() {
    const { dispatch } = this.props;
    const timeProfiles = await dispatch(UserActions.fetchCompanyTimeProfiles());
    this.setState({ timeProfiles });
  }

  async onTimeProfileClick(timeProfile) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const detailedTimeProfile = await dispatch(UserActions.getCompanyTimeProfileDetails(timeProfile.id));
      // Sanification of empty time profiles
      // format time profiles for form init
      if ((detailedTimeProfile.validityStart && detailedTimeProfile.validityEnd) && (detailedTimeProfile.validityStart !== -1 && detailedTimeProfile.validityEnd !== -1)) {
        detailedTimeProfile.isValidityVisible = true;
      } else {
        detailedTimeProfile.isValidityVisible = false;
      }

      const sanitizedTimeRanges = _.filter(detailedTimeProfile.timeRanges, timeRange => !_.isEmpty(timeRange.daysOfTheWeek));
      const timeRanges = _.map(sanitizedTimeRanges, timeRange => formatter.formatInputData(formatter.TIME_RANGE, timeRange));
      let formattedTimeProfile = {
        id: timeProfile.id,
        name: detailedTimeProfile.name,
        timeRanges: timeRanges,
        isValidityVisible: detailedTimeProfile.isValidityVisible,
        validityStart: detailedTimeProfile.isValidityVisible  ? moment(detailedTimeProfile.validityStart).valueOf() : 0,
        validityEnd: detailedTimeProfile.isValidityVisible ? moment(detailedTimeProfile.validityEnd).valueOf() : 0,
      }      

      dispatch(initialize('CompanyTimeProfileForm', formattedTimeProfile));
      this.setState({ isFormVisible: true });
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="unexpectedErrorMessage" /></h6>),
        },
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));

    }
  }

  onCreateNewTimeProfile() {
    const { dispatch } = this.props;
    this.setState({ isFormVisible: true });
    dispatch(initialize('CompanyTimeProfileForm', {
      timeRanges: [
        {
          daysOfTheWeek: [1, 2, 3, 4, 5, 6, 7],
          timeIntervalFrom: moment().startOf('day').valueOf(),
          timeIntervalTo: moment().endOf('day').valueOf(),
          holidays: true,
        }
      ],
    }));
  }

  async onTimeProfileFormSubmit(formData) {
    const { dispatch } = this.props;
    const isEditing = formData.id;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    const formattedTimeRanges = _.map(formData.timeRanges, timeRange => formatter.formatOutputData(formatter.TIME_RANGE, timeRange));
    const isValidityVisible = formData.isValidityVisible;

    const defaultCredentialRule = {
      name: formData.name,
      validityStart: isValidityVisible ? moment(formData.timeProfileTimeFrame.startDate).valueOf() : 0,
      validityEnd: isValidityVisible ? moment(formData.timeProfileTimeFrame.endDate).valueOf() : 0,
      timeRanges: formattedTimeRanges,
    };
    try {
      if (isEditing) {
        await dispatch(UserActions.editCompanyTimeProfile(formData.id, defaultCredentialRule));
      } else {
        await dispatch(UserActions.createCompanyTimeProfile(defaultCredentialRule));
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity key={isEditing} entity={'timeProfileEditSuccess'} /></h6>),
        },
      }));
      this.setState({ isFormVisible: false });
      this.onFetchTimeProfiles();
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity key={isEditing} entity={'timeProfileEditError'} /></h6>),
        },
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onSearchTimeProfile(text) {
    const { companyTimeProfiles } = this.props;
    if (text && text.search) {
      const filteredTimeProfiles = _.filter(companyTimeProfiles, profile => profile.name.includes(text.search));
      this.setState({ timeProfiles: filteredTimeProfiles })
    }
  }
  
  onSearchReset() {
    const { companyTimeProfiles } = this.props;
    this.setState({ timeProfiles: companyTimeProfiles });
  }

  async onDeleteTimeProfileRequest(timeProfileId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(UserActions.removeCompanyTimeProfile(timeProfileId));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="timeProfileDeleteSuccess" /></h6>),
        },
      }));
      this.setState({ isFormVisible: false });
      this.onFetchTimeProfiles();
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="timeProfileDeleteError" /></h6>),
        },
      }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onInitializeNewTimeRange(timeRangeId, fieldName) {
      const { dispatch } = this.props;
      dispatch(change('CompanyTimeProfileForm', `${fieldName}[${timeRangeId}].daysOfTheWeek`, [1, 2, 3, 4, 5]));
      dispatch(change('CompanyTimeProfileForm', `${fieldName}[${timeRangeId}].timeIntervalFrom`, moment().startOf('day').valueOf()));
      dispatch(change('CompanyTimeProfileForm', `${fieldName}[${timeRangeId}].timeIntervalTo`, moment().endOf('day').valueOf()));
      dispatch(change('CompanyTimeProfileForm', `${fieldName}[${timeRangeId}].holidays`, true));
  }

  render() {
    const { classes, themeName, dispatch, form, language, companyConfigurations } = this.props;
    const { isViewLoading, timeProfiles, isFormVisible } = this.state;
    const is12HoursFormat = language === LANGUAGES.ENGLISH;
    return (
      <div className={classes.container}>
        <div style={{ marginTop: 0 }}>
          <div style={{ position: 'absolute', top: 65, right: 0, left: 0 }}>
            <CompanyTimeProfileSearchForm
              onSubmit={searchValue => this.onSearchTimeProfile(searchValue)}
              onSearchReset={() => this.onSearchReset()}
              onCreateNew={() => this.onCreateNewTimeProfile()}
            />
          </div>
          <CompanyTimeProfilesListView
            isViewLoading={isViewLoading}
            timeProfilesData={timeProfiles}
            onRowClick={(timeProfile) => this.onTimeProfileClick(timeProfile)}
            onCreateNew={() => this.onCreateNewTimeProfile()}
          />
        </div>
        <OperationalView
          themeName={themeName}
          isVisible={isFormVisible}
          onClose={() => this.setState({ isFormVisible: false })}
          style={{ margin: 0, padding: 0 }}
          title={<Entity key={1} entity={"companyTimeProfileForm"} />}
        >
          <div style={{ padding: 10, paddingBottom: '30%' }}>
            <CompanyTimeProfileForm
              formData={form && form.values}
              onDeleteTimeProfileRequest={(timeProfileId) => this.onDeleteTimeProfileRequest(timeProfileId)}
              onSubmit={formData => this.onTimeProfileFormSubmit(formData)}
              companyConfigurations={companyConfigurations}
              is12HoursFormat={is12HoursFormat}
              onInitializeNewTimeRange={(timeRangeId, fieldName) => this.onInitializeNewTimeRange(timeRangeId, fieldName)}
              onValidateForm={() => dispatch(submit('CompanyTimeProfileForm'))}
            />
          </div>
        </OperationalView>
      </div>
    )
  }

}

export default withStyles(styles)(CompanyTimeProfilesSettingsOperationalSection);
